import React from 'react';
import { Check, X, HelpCircle } from 'lucide-react';
import { LicenseFeature } from '../../types/license';

interface FeatureCellProps {
  feature: LicenseFeature | undefined;
}

export const FeatureCell: React.FC<FeatureCellProps> = ({ feature }) => {
  if (!feature) return null;

  return (
    <div className="flex items-center justify-center gap-2">
      {feature.included ? (
        <Check className="w-5 h-5 text-green-500" />
      ) : (
        <X className="w-5 h-5 text-red-500" />
      )}
      {feature.additionalInfo && (
        <div className="group relative">
          <HelpCircle className="w-4 h-4 text-gray-400 cursor-help" />
          <div className="hidden group-hover:block absolute z-10 w-48 p-2 bg-gray-900 text-white text-xs rounded shadow-lg -top-2 left-6">
            {feature.additionalInfo}
          </div>
        </div>
      )}
    </div>
  );
};